import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { imgNbaLogo } from "../../assets";

export default function Footer() {
  return (
    <footer className="site-footer mt-16" data-node-id="251:134">
      <div className="container site-footer__inner">
        <div className="footer-meta">
          <div className="brand flex items-center gap-3" data-node-id="251:136">
            <img
              className="brand__logo"
              src={imgNbaLogo}
              alt="NBA logo"
              data-node-id="251:137"
            />
            <div className="brand__text" data-node-id="251:138">
              <div className="brand__name" data-node-id="251:139">
                NIGERIAN BAR ASSOCIATION
              </div>
              <div className="brand__sub" data-node-id="251:140">
                REMUNERATION PORTAL
              </div>
            </div>
          </div>

          <p className="footer-meta__desc" data-node-id="251:141">
            We enhance efficiency, transparency, and professionalism across the
            legal property market in Lagos State.
          </p>

          <div
            className="social"
            data-node-id="251:142"
            aria-label="Social links"
          >
            <a
              href="https://facebook.com"
              aria-label="Facebook"
              target="_blank"
              rel="noreferrer"
              className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
            >
              <Facebook size={24} aria-hidden="true" />
            </a>
            <a
              href="https://instagram.com"
              aria-label="Instagram"
              target="_blank"
              rel="noreferrer"
              className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
            >
              <Instagram size={24} aria-hidden="true" />
            </a>
            <a
              href="https://x.com"
              aria-label="Twitter"
              target="_blank"
              rel="noreferrer"
              className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
            >
              <Twitter size={24} aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <div>
            <h3 className="footer-links__title" data-node-id="251:157">
              COMPANY
            </h3>
            <div className="footer-links__list">
              <Link
                to="/about"
                data-node-id="251:159"
                className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
              >
                About Us
              </Link>
              <Link
                to="/service"
                data-node-id="251:163"
                className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
              >
                Service
              </Link>
              <Link
                to="/blog"
                data-node-id="251:164"
                className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
              >
                Blog
              </Link>
            </div>
          </div>
          <div>
            <h3 className="footer-links__title" data-node-id="251:158">
              LEGAL
            </h3>
            <div className="footer-links__list">
              <Link
                to="/faq"
                data-node-id="251:161"
                className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
              >
                FAQ
              </Link>
              <Link
                to="/privacy"
                data-node-id="251:160"
                className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                data-node-id="251:162"
                className="transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        className="footer-bottom flex flex-col items-center gap-2"
        data-node-id="251:166"
      >
        <span>
          Copyright &copy; 2025 Nigerian Bar Association. All Rights Reserved.
        </span>
        <span className="text-sm opacity-75">
          Powered by Synclexs Technology Solutions and Tenece
        </span>
      </div>
    </footer>
  );
}
